import { Box, SxProps, Theme } from "@mui/material";

interface IStatusCardProps {
    header: React.ReactNode;
    body: React.ReactNode;
    sx?: SxProps<Theme>;
}

const StatusCard = ({ header, body, sx }: IStatusCardProps) => {
    return (
        <Box sx={sx}>
            <Box>{header}</Box>
            <Box>{body}</Box>
        </Box>
    );
};

export default StatusCard;
